import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { API_BASE_URL } from '../../config.js'
import ReactHtmlParser from 'react-html-parser';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";
import '../preloading.css';

import {
    statisticsAction,
    statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';

const HrPayslipApproval = (props) => {

    const { fixNavbar } = props;

    const history = useHistory();

    // DatePicker hands back local midnight -- toISOString() would convert that to
    // UTC and hand us the previous day in IST, so build YYYY-MM-DD from local parts
    const toYmd = (date) => {
        if (!date) return "";
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    };

    const today = toYmd(new Date());

    const [user, setUser] = useState({
        start_date: today,
        end_date: today,
    })

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const { sortConfig, sortData, handleSort } = useSortData();

    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);

    const searchableFields = [
        "employee_id",
        "employee_name",
        "department_name",
        "month_payment",
        "reason",
    ];

    const safe = (val) => String(val ?? "").toLowerCase();

    const filteredItems =
        searchTerm.trim() === ""
            ? data
            : data.filter((item) =>
                searchableFields.some((field) =>
                    safe(item[field]).includes(searchTerm.toLowerCase())
                )
            );

    const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
    const indexOfLast = currentPage * entriesPerPage;
    const indexOfFirst = indexOfLast - entriesPerPage;
    const sortedItems = sortData(filteredItems);
    const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    const clearInput = () => {
        setSearchTerm("");
    };

    // payslip pdf opens in a new tab, same as the pending list
    const handleUpdate = (id) => {
        window.open(API_BASE_URL + '/payslip/' + id, '_blank')
    };

    const fetchRecords = async (start_date, end_date) => {
        setLoading(true);
        try {
            const response = await axios.post(
                API_BASE_URL + '/hr_payslip_approval_list',
                { start_date: start_date, end_date: end_date },
                {
                    headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
                }
            );

            setData(response.data.hr_payslip_approval_list || []);
            setCurrentPage(1);
        } catch (error) {
            const res = error.response;
            setData([]);
            if (!res) {
                toast.error('Network error', { position: 'bottom-right', theme: 'colored' });
            } else {
                toast.error(res.data?.message || `Error ${res.status}`, {
                    position: 'bottom-right',
                    autoClose: 5000,
                    theme: 'colored',
                });
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRecords(user.start_date, user.end_date);
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault();
        fetchRecords(user.start_date, user.end_date);
    };

    const columns = [
        { label: "Employee ID", key: "employee_id", sortable: true },
        { label: "Employee", key: "employee_name", sortable: true },
        { label: "Department", key: "department_name", sortable: true },
        { label: "Payslip Month", key: "month_payment", sortable: true },
        { label: "Applied On", key: "applied_on", sortable: true },
        { label: "Reason", key: "reason", sortable: true },
        { label: "HR Status", key: "hr_status", sortable: true },
    ];

    return (
        <>
            <div>
                <div>
                    <div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
                        <div className="container-fluid">

                            <ToastContainer />

                            <div className="section-body mb-4">
                                <Link to={`/Hr-payslip`}>
                                    <button className="btn btn-light me-2" type="button">
                                        Payslip
                                    </button>
                                </Link>
                                &nbsp;
                                <Link to={`/hr-payslip-approval`}>
                                    <button className="btn btn-primary" type="button">
                                        Payslip List
                                    </button>
                                </Link>
                            </div>

                        </div>
                    </div>

                    <div className="section-body">
                        <div className="container-fluid">
                            <div className="row clearfix">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header d-flex justify-content-between align-items-center">
                                            <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
                                                    <path d="M4 3a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z" /><path d="M2 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm0 1h12v14H2z" />
                                                </svg>
                                                Payslip Request List
                                            </h3>
                                        </div>

                                        <div className="card-body">
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">

                                                    <div className="col-md-3 col-sm-6">
                                                        <div className="form-group">
                                                            <label>From Date</label>
                                                            <DatePicker
                                                                selected={user.start_date ? new Date(user.start_date) : null}
                                                                onChange={(date) => {
                                                                    setUser(prev => ({ ...prev, start_date: toYmd(date) }));
                                                                }}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select From Date"
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3 col-sm-6">
                                                        <div className="form-group">
                                                            <label>To Date</label>
                                                            <DatePicker
                                                                selected={user.end_date ? new Date(user.end_date) : null}
                                                                onChange={(date) => {
                                                                    setUser(prev => ({ ...prev, end_date: toYmd(date) }));
                                                                }}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select To Date"
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3 col-sm-6">
                                                        <div className="form-group">
                                                            <label style={{ visibility: 'hidden', display: 'block' }}>Action</label>
                                                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                                                {loading ? "Loading..." : "GET"}
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="section-body">
                        <div className="container-fluid">
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="Payslip-list" role="tabpanel">
                                    <div className="card">

                                        <div className="card-header d-flex justify-content-between align-items-center">
                                            <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
                                                    <path d="M4 3a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z" /><path d="M2 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm0 1h12v14H2z" />
                                                </svg>
                                                List All Payslip Request
                                            </h3>

                                            <div
                                                className="card-options"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "12px",
                                                }}
                                            >
                                                <EntriesSelector
                                                    entriesPerPage={entriesPerPage}
                                                    setEntriesPerPage={setEntriesPerPage}
                                                    setCurrentPage={setCurrentPage}
                                                />

                                                <div style={{ position: "relative", width: "200px" }}>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Search"
                                                        value={searchTerm}
                                                        onChange={(e) => {
                                                            setSearchTerm(e.target.value);
                                                            setCurrentPage(1);
                                                        }}
                                                        style={{
                                                            width: "100%",
                                                            height: "30px",
                                                            fontSize: "13px",
                                                            borderRadius: "4px",
                                                            paddingRight: "28px",
                                                        }}
                                                    />

                                                    {searchTerm.length > 0 && (
                                                        <span
                                                            onClick={clearInput}
                                                            style={{
                                                                position: "absolute",
                                                                right: "8px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                cursor: "pointer",
                                                                color: "#aaa",
                                                                fontSize: "16px",
                                                                userSelect: "none",
                                                            }}
                                                        >
                                                            ✖
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {loading && (
                                            <div className="card-body">
                                                <div className="d-flex justify-content-center">
                                                    <div className="spinner"></div>
                                                </div>
                                            </div>
                                        )}

                                        {!loading && (
                                            <div className="card-body">
                                                <div className="table-responsive sticky-table-wrap">
                                                    <table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Action</th>
                                                                <th>Payslip</th>
                                                                {columns.map((col) => (
                                                                    <th
                                                                        key={col.key}
                                                                        onClick={col.sortable ? () => handleSort(col.key) : null}
                                                                        style={{ cursor: col.sortable ? "pointer" : "default" }}
                                                                    >
                                                                        {col.label}
                                                                        {col.sortable && (
                                                                            sortConfig.key === col.key
                                                                                ? (sortConfig.direction === "asc" ? " ▲" : " ▼")
                                                                                : " ⇅"
                                                                        )}
                                                                    </th>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {filteredData.length > 0 ? (
                                                                filteredData.map((hrpayslip) => (
                                                                    <tr key={hrpayslip.request_id}>
                                                                        <td>
                                                                            <Link to={`/hrpayslip-request?id=${hrpayslip.request_id}`}>
                                                                                <i className="fe fe-maximize" />
                                                                            </Link>
                                                                        </td>
                                                                        <td>
                                                                            {hrpayslip.hr_status_flag == 2 && (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn"
                                                                                    style={{ backgroundColor: 'rgb(233 132 143)' }}
                                                                                    onClick={() => handleUpdate(hrpayslip.pay_id)}
                                                                                >
                                                                                    <i className="fa-sharp fa-regular fa-file-pdf fa-2x"></i>
                                                                                </button>
                                                                            )}
                                                                        </td>
                                                                        <td><span>{hrpayslip.employee_id}</span></td>
                                                                        <td><span>{hrpayslip.employee_name}</span></td>
                                                                        <td><span>{hrpayslip.department_name}</span></td>
                                                                        <td><span>{hrpayslip.month_payment}</span></td>
                                                                        <td><span>{hrpayslip.applied_on}</span></td>
                                                                        <td><span>{hrpayslip.reason}</span></td>
                                                                        <td><span>{ReactHtmlParser(hrpayslip.hr_status)}</span></td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="9" style={{ color: 'red', textAlign: 'center', fontWeight: "bold" }}>No records found</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <Pagination
                                                    currentPage={currentPage}
                                                    totalPages={totalPages}
                                                    onPageChange={setCurrentPage}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    fixNavbar: state.settings.isFixNavbar,
    statisticsOpen: state.settings.isStatistics,
    statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
    statisticsAction: (e) => dispatch(statisticsAction(e)),
    statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})

export default connect(mapStateToProps, mapDispatchToProps)(HrPayslipApproval);
